import type { ImageLoader } from 'next/image';

const imageLoader: ImageLoader = ({ src, width, quality }) => {
    const q = quality || 75;

    if (src.startsWith('/images/')) {
        return `${src}?w=${width}&q=${q}`;
    }

    const baseUrl = process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_SITE_BASE_URL : '';

    return `${baseUrl}${src}?w=${width}&q=${q}`;
};

export default imageLoader;
